export default {
  name: 'top-header',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    handleSelect (val) {
      if (val == this.$route.name) {
        return false
      }
      let count = 0
      let tabs = JSON.parse(JSON.stringify(this.$store.state.tabs))
      tabs.map(tab => {
        if (tab == val) {
          count++
        }
      })
      if (count == 0) {
        tabs.push(val)
      }
      // 设置tab标签
      this.$store.commit('setField', {
        name: 'tabs',
        val: tabs
      })
      // 设置tab标签
      this.$store.commit('setField', {
        name: 'menuActive',
        val: val
      })
      this.$router.push({
        'name': val
      })
    }
  },
  // 计算属性
  computed: {
  },
  created () {
    let self = this
    // 设置tab标签
    this.$store.commit('setField', {
      name: 'menuActive',
      val: self.$route.name
    })
  },
}



// WEBPACK FOOTER //
// ./src/views/common/header/script.js